import set from 'lodash/set';
import state from 'store/state/global';
import types from 'store/types/global';

const initialState = state;

export default (state = initialState, action) => {
  const { type, key, data } = action;

  switch (type) {
    case types.GLOBAL_SET:
      set(state, key, data);
      return { ...state };
    default:
      return state;
  }
};
